import dayjs from 'dayjs'
import { z } from 'zod'
import {
  DONOR_DOCUMENT_ACCEPTED_EXTENSIONS,
  DONOR_DOCUMENT_DOCTOR_MAX_LENGTH,
  DONOR_DOCUMENT_MAX_FILE_SIZE,
  DONOR_DOCUMENT_TYPES,
} from '@/entities/donor/model'

const hasAcceptedExtension = (file: File) => {
  const name = file.name.toLowerCase()
  return DONOR_DOCUMENT_ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext))
}

/** Mirrors the backend's checks so most mistakes never leave the form. */
export const donorDocumentSchema = (t: (key: string) => string) =>
  z.object({
    date: z
      .string()
      .min(1, t('donor_detail.documents.form.date_required'))
      .refine(
        (value) => !dayjs(value).isAfter(dayjs(), 'day'),
        t('donor_detail.documents.form.date_in_future'),
      ),
    type: z.enum(DONOR_DOCUMENT_TYPES).optional(),
    note: z.string().trim().optional(),
    doctor: z
      .string()
      .trim()
      .max(
        DONOR_DOCUMENT_DOCTOR_MAX_LENGTH,
        t('donor_detail.documents.form.doctor_too_long'),
      )
      .optional(),
    file: z
      .instanceof(File)
      .refine(hasAcceptedExtension, t('donor_detail.documents.form.file_type'))
      .refine(
        (file) => file.size <= DONOR_DOCUMENT_MAX_FILE_SIZE,
        t('donor_detail.documents.form.file_size'),
      )
      .optional(),
  })

export type DonorDocumentFormValues = z.infer<
  ReturnType<typeof donorDocumentSchema>
>
